<div class="p-3 p-md-4">
  <h1 class="title">{{title}}</h1>
  <div [innerHTML]="text | safe: 'html'"></div>
</div>

